import React from 'react'
import { logger, metrics } from 'lib/slardar-utils'
import Exception from 'Components/exception'
const logoPic = require('static/logo.svg')

function Error() {
  return (
    <section className="tw-fixed tw-left-0 tw-right-0 tw-bottom-0 tw-top-0 tw-bg-common-white">
      <header className="tw-position tw-left-0 tw-right-0 tw-h-84 tw-bg-white">
        <a
          href="/"
          title="懂车帝"
          className="fl logo"
          style={{
            margin: '19px 0 0 74px',
            width: '141px',
            height: '46px',
          }}
        >
          <img src={logoPic} alt="懂车帝" />
        </a>
      </header>
      <Exception type={500} />
    </section>
  )
}
Error.getInitialProps = async ({
  pathname,
  asPath,
  query,
  req,
  res,
  err,
}: any) => {
  const statusCode = res ? res.statusCode : err ? err.statusCode : 404
  const referrer = res ? req?.headers?.referer : document?.referrer
  if (statusCode === 404) {
    metrics.counter('404', {
      from_error_page: true,
    })
  } else if (res && req?.metrics && req?.logger) {
    // server side error.
    req.metrics.emitCounter('error_page', 1, undefined, {
      statusCode,
    })
    req.logger.error(
      `[error page] error_page referrer = ${referrer} status code = ${statusCode} error message = ${err?.message} error stack = ${err?.stack} url = ${asPath}`
    )
  } else if (!res) {
    // client side error.
    metrics.counter('error_page', {
      statusCode,
    })
    logger.error(
      `[error page] error_page referrer = ${referrer} error message = ${err?.message} error stack = ${err?.stack} url = ${asPath}`
    )
  }

  return {
    err,
    statusCode,
    pathname,
    asPath,
    query,
    _pageType: 'error',
  }
}
export default Error
